import { useEffect, useState } from "react";
import slide1 from "../assets/slide1.jpg";
import slide2 from "../assets/slide2.jpg";
import slide3 from "../assets/slide3.jpg";
import slide4 from "../assets/slide4.jpg";
import slide5 from "../assets/slide5.jpg";

const images = [slide1, slide2, slide3, slide4, slide5];

export default function Home() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="home" className="home">
     <div className="slider-full">
      <button className="slider-btn left" onClick={() => setCurrent((current - 1 + images.length) % images.length)}>‹</button>
      <img src={images[current]} alt="Slideshow" />
      <button className="slider-btn right" onClick={() => setCurrent((current + 1) % images.length)}>›</button>
    </div>


    <p className="home-text">
    <span>"Your Little Support  = Huge Impact In Their Lives"</span>
    <br />
    <span>Together, let's build, care and support.</span>
    </p>
    </section>
  );
}
